import { createContext, type ReactNode, useContext, useMemo } from 'react';

import type CurrentRouteValues from '../_hooks/useCurrentRoute/types';
import useWizardState from '../_hooks/useWizardState';
import type { UseWizardState } from '../_hooks/useWizardState/types';

interface WizardStateProviderProps {
  readonly children: ReactNode;
  readonly currentRoute: CurrentRouteValues;
}

export const WizardStateContext = createContext<UseWizardState | null>(null);

export const useWizardStateContext = (): UseWizardState => {
  const ctx = useContext(WizardStateContext);
  if (!ctx) {
    throw new Error(
      'Check to make sure you have the Wizard Provider included in your component tree',
    );
  }
  return ctx;
};

const WizardStateProvider = ({
  children,
  currentRoute,
}: WizardStateProviderProps) => {
  const data: UseWizardState = useWizardState({ currentRoute });

  const value = useMemo(() => {
    return data;
  }, [data]);

  return (
    <WizardStateContext.Provider value={value}>
      {children}
    </WizardStateContext.Provider>
  );
};
export default WizardStateProvider;
